.loading-indicator {
  width: 100px;
  height: 100px;
  margin: auto;
  margin-top: 150px;
}
